/**
 * Action Session 관리 유틸리티
 *
 * 하나의 사용자 작업(예: Save 버튼 클릭)에서 발생하는 여러 API 호출을
 * 동일한 action_session_id로 묶어서 백엔드에서 하나의 세션으로 추적할 수 있게 합니다.
 *
 * 사용법:
 *   setActionSessionId(crypto.randomUUID());
 *   try {
 *     await apiCall1();
 *     await apiCall2();
 *   } finally {
 *     clearActionSessionId();
 *   }
 */

let _currentSessionId: string | null = null;

export function getActionSessionId(): string | null {
  return _currentSessionId;
}

export function setActionSessionId(sessionId: string): void {
  _currentSessionId = sessionId;
}

export function clearActionSessionId(): void {
  _currentSessionId = null;
}
